// 5-inch star shell illumination for night actions. Fired from the secondary
// battery on I, a flare ignites high over the far side of the designated
// target (beyond it, so the hull silhouettes for the director — the real
// doctrine) and sinks slowly on its parachute. The flare is a glow sprite
// plus a real PointLight, so the Phong sea gets a pool of moonlight-colored
// glint under it; the unlit voxel enemies are brightened by enemy.js while
// they stand in the light.

import * as THREE from "three";

export class StarShells {
  constructor(G) {
    this.G = G;
    this.flares = [];
    this.cool = 0;
    const cv = document.createElement("canvas");
    cv.width = cv.height = 64;
    const ctx = cv.getContext("2d");
    const g = ctx.createRadialGradient(32, 32, 2, 32, 32, 30);
    g.addColorStop(0, "rgba(255,250,232,1)");
    g.addColorStop(0.28, "rgba(255,238,190,0.8)");
    g.addColorStop(1, "rgba(255,222,150,0)");
    ctx.fillStyle = g;
    ctx.fillRect(0, 0, 64, 64);
    this.tex = new THREE.CanvasTexture(cv);
  }

  fire() {
    const G = this.G;
    if (!G.night) { G.hud.log("SAVE THE STAR SHELLS FOR THE DARK"); return; }
    if (!G.fc.target) { G.hud.log("ILLUMINATION: NO TARGET DESIGNATED — CIC HOLDS THE PICTURE", "bad"); return; }
    if (this.cool > 0) return;
    this.cool = 11;
    const t = G.fc.target;
    const p = G.shipWorldPos();
    const b = Math.atan2(t.pos.x - p.x, t.pos.y - p.z);
    // aim the burst beyond the target with a little scatter
    const bx = t.pos.x + Math.sin(b) * 550 + (Math.random() - 0.5) * 300;
    const bz = t.pos.y + Math.cos(b) * 550 + (Math.random() - 0.5) * 300;
    G.audio.secondary();
    G.hud.log("5-INCH ILLUMINATION AWAY — STAR SHELL IN 8 SECONDS");
    setTimeout(() => { if (!G.over) this.ignite(bx, bz); }, 8000);
  }

  ignite(x, z) {
    const G = this.G;
    const sprite = new THREE.Sprite(new THREE.SpriteMaterial({
      map: this.tex, transparent: true, depthWrite: false, depthTest: false,
    }));
    sprite.renderOrder = 980; // the glow reads through its own smoke
    sprite.scale.set(64, 64, 1);
    const light = new THREE.PointLight(0xffeec2, 9, 8000, 1.05);
    const grp = new THREE.Group();
    grp.add(sprite, light);
    grp.position.set(x, 640, z);
    G.scene.add(grp);
    this.flares.push({ grp, sprite, vy: -7.5, life: 78, sway: Math.random() * 6 });
    G.hud.log("STAR SHELL BURNING — TARGET IN THE LIGHT", "ok");
  }

  // Is a target standing in anyone's light?
  isLit(e) {
    if (!e) return false;
    for (const f of this.flares) {
      if (f.grp.position.y < 45) continue; // guttering into the sea
      const d = Math.hypot(e.pos.x - f.grp.position.x, e.pos.y - f.grp.position.z);
      if (d < 2300) return true;
    }
    return false;
  }

  update(dt) {
    this.cool = Math.max(0, this.cool - dt);
    for (let i = this.flares.length - 1; i >= 0; i--) {
      const f = this.flares[i];
      f.life -= dt;
      f.sway += dt;
      f.grp.position.y += f.vy * dt;
      f.grp.position.x += Math.sin(f.sway * 0.7) * dt * 3;
      f.grp.position.z += Math.cos(f.sway * 0.5) * dt * 3;
      const s = 60 + Math.sin(f.sway * 11) * 9; // parachute flicker
      f.sprite.scale.set(s, s, 1);
      if (Math.random() < dt * 2) {
        this.G.worldFx.spawn(new THREE.Vector3(f.grp.position.x, f.grp.position.y + 22, f.grp.position.z), {
          count: 1, speed: 1, life: 3, size: 2.6, colors: [0x9a9083, 0x7a7268],
          gravity: 1.4, drag: 0.5, grow: 2,
        });
      }
      if (f.life <= 0 || f.grp.position.y < 6) {
        this.G.scene.remove(f.grp);
        this.flares.splice(i, 1);
      }
    }
  }
}
